<template>
  <div>
    <van-search v-model="keyword" placeholder="请输入搜索关键词" @search="onSearch"/>
    <van-cell-group>
      <span v-for="channel in channels" :key="channel.group">
        <van-cell>
          <b style="text-align: center;">{{ channel.group }} （共{{ channel.list.length }}个）</b>
        </van-cell>
        <van-cell v-for="item in channel.list" :key="item.title" @click="selectLine(item)" v-if="isMatch(item)">
          {{ item.title }}
        </van-cell>
      </span>
    </van-cell-group>
    <van-action-sheet :show="showLines" :actions="actions" @select="handleLine" />
  </div>
</template>

<script>
import { getChannels } from '@/api/vod'
import { Base64 } from 'js-base64'
import { baseMixin } from '@/libs/app-mixin'

export default {
  name: 'VodLive',
  mixins: [baseMixin],
  data () {
    return {
      channels: [],
      channel: [],
      showLines: false,
      actions: [],
      lines: [],
      keyword: '',
      filter: ''
    }
  },
  methods: {
    proxyImg (url) {
      return 'http://cloud.ai-ifast.com/mesh/cloud/vod/proxy?url=' + Base64.encode(url)
    },
    onSearch () {
      this.filter = this.keyword
    },
    isMatch (channel) {
      if (this.keyword.length === 0) {
        return true
      }
      if (channel.title.indexOf(this.keyword.toUpperCase()) >= 0) {
        return true
      }
      return false
    },
    getChannels () {
      this.$parent.progressOn()
      getChannels().then(res => {
        this.channels = res.result
        this.$parent.progressOff()
      })
    },
    selectLine (channel) {
      this.channel = channel
      this.actions = []
      this.lines = channel.lines
      channel.lines.forEach((v, i) => {
        if (this.isIPv6(v.split('/')[2].replaceAll('[', '').replaceAll(']', ''))) {
          this.actions.push({
            name: 'IPv6 线路 ' + (i + 1)
          })
        } else {
          this.actions.push({
            name: '线路 ' + (i + 1)
          })
        }
      })
      this.showLines = true
    },
    handleLine (e) {
      this.lines.forEach((v, i) => {
        if ('线路 ' + (i + 1) === e.name || 'IPv6 线路 ' + (i + 1) === e.name) {
          this.playUrl(this.channel.title + ' ' + e.name + '::::' + v)
        }
      })
    },
    playUrl (content) {
      if (typeof window.webkit === 'undefined') {
        window.open(content.split('::::')[1])
        return
      }
      window.webkit.messageHandlers.play.postMessage(content)
    }
  },
  mounted () {
    this.$parent.navLeftText = ''
    this.getChannels()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Vod/Live.vue